module.exports = __webpack_public_path__ + "img/bubble_fill.5b1abb2d.svg";